const getActivityDistributionChart = (data = []) => ({
  backgroundColor: 'transparent',
  tooltip: {
    trigger: 'item',
    formatter: (params) =>  `${params.name}: ${params.value}`,
    textStyle: {
      fontFamily: 'Inter, "Segoe UI", Roboto, sans-serif',
      fontSize: 12
    }
  },
  polar: {
    radius: ['15%', '90%']
  },
  
  angleAxis: {
    type: 'category',
    data: data.map(d => d.label || ''), // ✅ ensure non-undefined strings
    startAngle: 90,
    axisLabel: {
      fontFamily: 'Inter, "Segoe UI", Roboto, sans-serif',
      fontSize: 11,
      color: '#555',
      interval: 0,
      rotate: 45
    },
    axisTick: { show: false },
    axisLine: { show: false }
  },
  radiusAxis: {
    axisLine: { show: false },
    axisLabel: { show: false },
    splitLine: {
      lineStyle: {
        color: '#eee',
        type: 'dashed'
      }
    }
  },
  series: [
    {
      type: 'bar',
      coordinateSystem: 'polar',
      roundCap: true,
      data: data.map((d, i) => ({
        value: d.value,
        name: d.name || `Item ${i + 1}`, // ✅ fallback name
        itemStyle: { color: d.color || '#999' }
      })),
      label: {
        show: true,
        position: 'middle',
        formatter: (p) => `${p.value}`,
        fontFamily: 'Inter, "Segoe UI", Roboto, sans-serif',
        fontSize: 11,
        color: '#333'
      }
    }
  ],
  animationEasing: 'cubicOut',
  animationDuration: 1200
});

export default getActivityDistributionChart;
